import { getHomePageUrl } from '../../utils/aem-utils';

import {
  HOOK_DTMOBJ,
  HOOK_WRAPPER_PAGE,
  INJECTED_HP_HEADERS,
  SELECTOR_NATIVE_SPONSORED,
  SELECTOR_PLAYER_LIVE_CONTAINER_PLAYER,
  SELECTOR_SENTINEL,
  SELECTOR_TAG_LIST,
} from './constants';
import { httpGetHomepage, injectHP, injectNewFontsFromHP, manageParselyNodeDoms, runObserver } from './helpers';
import { injectedHomepageState } from './state';

/**
 * Homepage Observer
 */
const addInjectedHP = async () => {
  if (injectedHomepageState.getState('appendHomePage')) {
    injectedHomepageState.setState('appendHomePage', false);
    const $hpHtml = await httpGetHomepage(injectedHomepageState.getState('hpUrl'), INJECTED_HP_HEADERS);
    if ($hpHtml) {
      // Cache DOM queries to avoid repeated lookups
      const $hpHtmlHeadNode = $hpHtml.head;
      const $hpHtmlSelectedDTMNode = $hpHtml.querySelector(HOOK_DTMOBJ);
      const $hpHtmlSelectedNode = $hpHtml.querySelector(HOOK_WRAPPER_PAGE);
      const $livePlayer = $hpHtmlSelectedNode.querySelector(SELECTOR_PLAYER_LIVE_CONTAINER_PLAYER);
      if (!$hpHtmlSelectedDTMNode || !$hpHtmlSelectedNode) {
        return;
      }
      // Only update if content is different to avoid unnecessary DOM operations
      injectedHomepageState.setState('hpHtmlSelectedDTM', $hpHtmlSelectedDTMNode.innerHTML);
      manageParselyNodeDoms($hpHtmlSelectedNode);
      injectNewFontsFromHP($hpHtmlHeadNode);
      injectHP($hpHtmlSelectedNode);
      runObserver();
      injectedHomepageState.setState('hpInArticleRailLiveSettings', $livePlayer?.outerHTML || null);
    }
  }
};

/**
 * Render Homepage
 */
export const init = () => {
  // Intersection Observer for .c-tag-list
  const $injectedHPSentinel = document.querySelector(SELECTOR_SENTINEL);
  const $tagList = document.querySelector(SELECTOR_TAG_LIST);
  const $nativeSponsored = document.querySelector(SELECTOR_NATIVE_SPONSORED);
  if ($injectedHPSentinel || $tagList || $nativeSponsored) {
    const observer = new window.IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            injectedHomepageState.setState('hpUrl', getHomePageUrl());
            injectedHomepageState.setState('currentPageUrl', window.location.href);
            addInjectedHP();
            obs.unobserve(entry.target); // Only trigger once
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe($injectedHPSentinel || $tagList || $nativeSponsored);
  }
};
